<template>
  <div
    v-show="showGiveawayConfirmationModal"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 px-4"
  >
    <div
      class="relative bg-gradient-to-r from-[#1E1E1E] via-[#2A2A2A] to-[#3A3A3A] w-full max-w-md md:max-w-lg lg:max-w-xl py-10 px-5 rounded-2xl text-center flex flex-col items-center shadow-xl"
    >
      <!-- Close Button -->
      <button
        @click="closeJoinModal"
        class="absolute top-4 right-6 text-gray-300 hover:text-white text-4xl font-bold transition duration-200"
      >
        &times;
      </button>

      <!-- Giveaway Title -->
      <h2 class="text-yellow-400 text-2xl sm:text-3xl font-bold drop-shadow text-center">
        {{ giveawayDetails.title }}
      </h2>

      <!-- Title -->
      <h3
        class="text-yellow-400 text-lg sm:text-xl font-bold mb-4 drop-shadow text-center"
      >
        Enter Giveaway Code
      </h3>

      <!-- Code Input Container -->
      <div class="relative w-full max-w-[330px]">
        <!-- Code Input -->
        <input
          v-model="joinCode"
          type="text"
          placeholder="Enter code"
          @input="clearErrorMessage"
          class="w-full px-4 py-2 rounded-lg bg-black text-white border border-gray-500 focus:outline-none focus:border-[#1294F0] text-base"
        />

        <!-- Error Message Container (with its own height) -->
        <div v-if="errorMessage" class="flex justify-end items-center w-full h-6 mt-2">
          <p class="text-red-400 text-sm text-end my-1">
            {{ errorMessage }}
          </p>
        </div>
      </div>

      <!-- Join Button (fixed width, centered) -->
      <button
        @click="submitJoinGiveaway"
        :disabled="!joinCode || loadingJoin"
        class="w-full max-w-[330px] px-6 py-2 mt-4 bg-white text-black font-semibold rounded-lg hover:bg-gray-300 transition disabled:opacity-50"
      >
        <span
          v-if="loadingJoin"
          class="animate-spin border-2 border-black border-t-transparent rounded-full w-5 h-5 inline-block mr-2 align-middle"
        ></span>
        Join Giveaway
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    showGiveawayConfirmationModal: Boolean,
    giveawayDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      joinCode: "",
      loadingJoin: false,
      errorMessage: "",
    };
  },
  methods: {
    closeJoinModal() {
      this.$emit("close");
      this.joinCode = "";
      this.errorMessage = "";
    },
    clearErrorMessage() {
      this.errorMessage = "";
    },
    submitJoinGiveaway() {
      if (!this.joinCode) return;

      const token = localStorage.getItem("ballyboy-access-token");
      this.loadingJoin = true;

      const formData = {
        code: this.joinCode,
        giveawayId: this.giveawayDetails._id,
      };

      axios
        .post(process.env.VUE_APP_BASE_API + "/api/giveaways/join", formData, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          this.closeJoinModal();
          this.$emit("joined-successfully");
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else if (error.response.status === 400) {
              const message = error.response.data.message;
              this.errorMessage = message; // Set the error message when the code is wrong
            }
          } else {
            console.error("Unexpected error:", error.message);
          }
        })
        .finally(() => {
          this.loadingJoin = false;
        });
    },
  },
};
</script>
